import React from "react";
import Container from "./Container";

const TextSection = () => {
  return (
    <div className="bg-secondary text-center flex justify-center py-12 md:py-20 font-poppins font- text-white">
      <Container>
        <h1 className="uppercase text-2xl smtext-4xl md:text-5xl lg:text-6xl">
          U.S Sports Franchise valuations as of{" "}
          <span className="font-semibold">2021</span>
        </h1>
      </Container>
    </div>
  );
};

export default TextSection;
